import React from 'react';
import * as PropTypes from 'prop-types';
import Section from '@/yema-designkit/webkit/layouts/Section';

const CMS_Body = ({ content }) => {
    const createMarkup = () => {
        if (!content || content === '') return '';

        let parsedContent = content;
        parsedContent = parsedContent.replace(
            /<iframe\s*(.*)>\s*(.*)<\/iframe>/g,
            '<div class="relative pb-[56.25%] h-0 shadow-down overflow-hidden"><iframe class="absolute top-0 left-0 w-full h-full" $1>$2</iframe></div>'
        );
        return { __html: parsedContent };
    };

    return (
        <Section className='body_content'>
            <div className='container-fluid'>
                <div className='rich-text' dangerouslySetInnerHTML={createMarkup()} />
                <div className='flow-root' />
            </div>
        </Section>
    );
};

CMS_Body.defaultProps = {};

CMS_Body.propTypes = {
    content: PropTypes.string.isRequired,
};

export default CMS_Body;
